module.exports = __webpack_public_path__ + "static/media/mother.045d6ccc.svg";